import "./App.css";
import "./index.css";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "./utils/toastContext";
import "./utils/i18n";
import { StyledEngineProvider } from "@mui/material/styles";
import { apiClient } from "./services/apiClient";
import { setupInterceptors } from "./services/interceptors";
import { ErrorProvider } from "./utils/errorContext";
import AppRouter from "./router/appRouter";
import { colors } from "./theme/color";
import Auth0ProviderWithRouter from "./auth/auth0ProviderWithRouter ";

setupInterceptors(apiClient);

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Poppins",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // normal case
          fontFamily: "poppins",
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "170%",
          letterSpacing: "0%",
          textAlign: "center",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "Poppins",
        },
      },
    },
  },
  palette: {
    primary: {
      main: colors.bgColor,
    },
    background: {
      default: "#f9fafb",
    },
    text: {
      primary: colors.textColor,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1440,
      xl: 2560,
    },
  },
});
// const oktaAuth = new OktaAuth(oktaConfig);

// const restoreOriginalUri = async (_oktaAuth, originalUri) => {
//   window.location.replace(
//     toRelativeUrl(originalUri || "/", window.location.origin)
//   );
// };

function App() {
  return (
    <BrowserRouter>
      <Auth0ProviderWithRouter>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <ToastProvider>
              <ErrorProvider>
                <AppRouter />
              </ErrorProvider>
            </ToastProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </Auth0ProviderWithRouter>
    </BrowserRouter>
  );
}

export default App;
